import context from '@truckdown/components-systems';
import { IAccountManager, UpdateAccountFleetInfoModel, AccountModel } from "@truckdown/accounts";
import { defineComponent, ref, Ref, computed, onMounted } from "vue";
import { isGeneralAdmin, showMessage } from "../../Utilities/Utilities";

interface IData {
    isLoading: Ref<boolean>,
    account: Ref<AccountModel>,
    update: Ref<UpdateAccountFleetInfoModel>
};

const getInitialData = function (props: any) {

    var update = {
        accountId: props.account.id,
        fleetSize: props.account.properties.fleetSize,
        iftaNumber: props.account.properties.iftaNumber,
        dotNumber: props.account.properties.dotNumber
    } as UpdateAccountFleetInfoModel;

    return {
        isLoading: ref<boolean>(false),
        account: ref<AccountModel>(props.account),
        update: ref<UpdateAccountFleetInfoModel>(update)
    } as IData;
}

const getMethods = function (props: any, data: IData, ctx: any) {
    return {
        cancelClick: function (): void {
            ctx.emit(cancelEventName);
        },
        saveClick: async function (): Promise<void> {
            await save(data, props, ctx);
        }
    }
}


const save = async function (data: IData, props: any, ctx: any): Promise<void> {
    if (!data.isLoading.value) {
        data.isLoading.value = true;

        try {
            let accountManager = await context.getService<IAccountManager>('IAccountManager');
            var response = await accountManager.updateFleetInfo(data.update.value);

            if (!response || !response.ok) {
                console.log("Error updating company fleet info: " + response.message);
                showMessage("Error updating company fleet info.", "danger", true, true);
            } else {
                showMessage("Company fleet info was succssfully updated.", "success", true, true);
                ctx.emit(updatedEventName, response.data);
            }
        } catch (err) {
            console.error(err);
        } finally {
            data.isLoading.value = false;
        }
    }
}

const updatedEventName = 'update';
const cancelEventName = 'cancel';

export default defineComponent({
    props: {
        account: {
            type: Object as () => AccountModel,
            required: true
        }
    },
    emits: [updatedEventName, cancelEventName],
    setup: function (props, ctx) {
        let data = getInitialData(props);
        let methods = getMethods(props, data, ctx);

        return {
            ...data,
            ...computed,
            ...methods,
        };
    }
});